// extracted by mini-css-extract-plugin
module.exports = {"modal":"ModalReportOverlay_modal__1LZTX","timesCircle":"ModalReportOverlay_timesCircle__2qNB6"};